import NavBar from "./components/NavBar";
import HomePage from "./pages/HomePage";
import AddTaskPage from "./pages/AddTaskPage";
import EditTaskPage from "./pages/EditTaskPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage />}></Route>
        <Route path="/addTask" element={<AddTaskPage />}></Route>
        <Route path="/editTask/:taskId" element={<EditTaskPage />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
